import { Application } from "@hotwired/stimulus"

import AutoSubmitController from "./auto_submit_controller"
import BookingController from "./booking_controller"
import BookingFormController from "./booking_form_controller"
import InlineEditController from "./inline_edit_controller"
import PushSubscriptionController from "./push_subscription_controller"
import TableSortController from "./table_sort_controller"
import TaskController from "./task_controller"

window.Stimulus = Application.start()

Stimulus.register("auto-submit", AutoSubmitController)
Stimulus.register("booking", BookingController)
Stimulus.register("booking-form", BookingFormController)
Stimulus.register("inline-edit", InlineEditController)
Stimulus.register("push-subscription", PushSubscriptionController)
Stimulus.register("table-sort", TableSortController)
Stimulus.register("task", TaskController)
